import api from '../api';

async function fetchSlots(params) {
    const response = await api.get('slots', { params });
    return response.data;
}

export { fetchSlots };
